import { RiskLevel } from "@/types/sorin";
import { cn } from "@/lib/utils";

interface RiskBadgeProps {
  level: RiskLevel;
  showLabel?: boolean;
}

export const RiskBadge = ({ level, showLabel = true }: RiskBadgeProps) => {
  const config = {
    Rendah: { bg: "bg-success", text: "text-success-foreground", icon: "✓" },
    Sedang: { bg: "bg-warning", text: "text-warning-foreground", icon: "⚠" },
    Tinggi: { bg: "bg-destructive", text: "text-destructive-foreground", icon: "⚠" },
  };
  
  const { bg, text, icon } = config[level];
  
  return (
    <div className={cn(
      "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-bold text-sm",
      bg, text
    )}>
      <span>{icon}</span>
      {showLabel && <span>{level}</span>}
    </div>
  );
};
